//总院相关路由

export default [
  {
    path: "/",
    name: "generalIndex",
    component: resolve => require(["@/views/general-hospital/index"], resolve),
    meta: {
      title: "广元市互联网分院"
    }
  },
  {
    path: "/general-hospital/doctor-list",
    name: "doctorList",
    component: resolve =>
      require(["@/views/general-hospital/doctor-list"], resolve),
    meta: {
      title: "复诊开方"
    }
  },
  {
    path: "/general-hospital/global-search",
    name: "globalSearch",
    component: resolve =>
      require(["@/views/general-hospital/global-search"], resolve),
    meta: {
      title: "搜索"
    }
  },
  {
    path: "/general-hospital/my-attention",
    name: "myAttention",
    component: resolve =>
      require(["@/views/general-hospital/my-attention"], resolve),
    meta: {
      title: "我的关注"
    }
  },
  {
    path: "/general-hospital/self-invoicing",
    name: "selfInvoicing",
    component: resolve =>
      require(["@/views/general-hospital/self-invoicing"], resolve),
    meta: {
      title: "自助开单"
    }
  },
  {
    path: "/general-hospital/medical-guidance",
    name: "medicalGuidance",
    component: resolve =>
      require(["@/views/general-hospital/medical-guidance"], resolve),
    meta: {
      title: "就医指导"
    }
  },
  {
    path: "/general-hospital/visit-record",
    name: "visitRecord",
    component: resolve =>
      require(["@/views/general-hospital/visit-record"], resolve),
    meta: {
      title: "诊疗记录"
    }
  },
  {
    path: "/general-hospital/follow-up-record",
    name: "followUpRecord",
    component: resolve =>
      require(["@/views/general-hospital/follow-up-record"], resolve),
    meta: {
      title: "复诊记录"
    }
  },
  {
    path: "/general-hospital/consul-details",
    name: "consulDetails",
    component: resolve =>
      require(["@/views/general-hospital/consul-details"], resolve),
    meta: {
      title: "问诊详情"
    }
  },
  {
    path: "/general-hospital/complaint",
    name: "complaint",
    component: resolve =>
      require(["@/views/general-hospital/complaint"], resolve),
    meta: {
      title: "投诉与反馈"
    }
  },
  {
    path: "/general-hospital/internet-fy-page",
    name: "fyPage",
    component: resolve =>
      require(["@/views/general-hospital/internet-fy-page.vue"], resolve),
    meta: {
      title: "互联网分院"
    }
  },
  {
    path: "/general-hospital/agreement",
    name: "agreement",
    component: resolve =>
      require(["@/views/general-hospital/agreement"], resolve),
    meta: {
      title: "广元市互联网分院"
    }
  },
  {
    path: "/general-hospital/find-dep",
    name: "findDep",
    component: resolve =>
      require(["@/views/general-hospital/find-dep"], resolve),
    meta: {
      title: "复诊开方"
    }
  },
  {
    path: "/general-hospital/lists",
    name: "generalList",
    component: resolve => require(["@/views/general-hospital/lists"], resolve),
    meta: {
      title: "便民服务"
    }
  },
  {
    path: "/general-hospital/activity-list",
    name: "activityList",
    component: resolve =>
      require(["@/views/general-hospital/activity-list"], resolve),
    meta: {
      title: "活动列表"
    }
  },
  {
    path: "/general-hospital/agreement-activity",
    name: "agreementActivity",
    component: resolve =>
      require(["@/views/general-hospital/agreement-activity"], resolve),
    meta: {
      title: "在线参加活动须知"
    }
  },
  {
    path: "/general-hospital/activity-info",
    name: "activityInfo",
    component: resolve =>
      require(["@/views/general-hospital/activity-info"], resolve),
    meta: {
      title: "活动详情"
    }
  },
  {
    path: "/general-hospital/article-info",
    name: "articleInfo",
    component: resolve =>
      require(["@/views/general-hospital/article-info"], resolve),
    meta: {
      title: "文章详情"
    }
  },
  {
    path: "/general-hospital/multi-consult",
    name: "multiConsult",
    component: resolve =>
      require(["@/views/general-hospital/multi/consult"], resolve),
    meta: {
      title: "多元咨询"
    }
  },
  {
    path: "/general-hospital/health-science-detail",
    name: "healthScienceDetail",
    component: resolve =>
      require(["@/views/general-hospital/health-science-detail"], resolve),
    meta: {
      title: ""
    }
  },
  {
    path: "/general-hospital/health-science",
    name: "healthScience",
    component: resolve =>
      require(["@/views/general-hospital/health-science"], resolve),
    meta: {
      title: "科普文章"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/general-hospital.js